<template>

    <span class="vz-field-message" :class="{ 'vz-error': type === 'error', 'vz-info': type === 'info' }">
      <slot/>
    </span>

</template>

<script>
import VzBase from '../vz-base';

export default {

  name: 'VzFieldMessage',
  extends: VzBase,

  props: {
    type: {
      type: String,
      default: ''
    }
  }

}
</script>

<style>

.vz-field-message {
  display: block;
  width: 100%;
  position: relative;
  border-radius: 4px;
  font-size: 0.85em;
  padding: 14px 32px;
  margin-top: 8px;
}

.vz-field-message.vz-error {
  background-color: #DC0000;
  color: #ffffff;
}

.vz-field-message.vz-error:before {
  content: "";
  display: block;
  position: absolute;
  top: -6px;
  left: 50%;
  margin-left: -3px;
  border-top-width: 0;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #DC0000;
  border-left: 6px solid transparent;
}

.vz-field-message.v-enter-active,
.vz-field-message.v-leave-active
{
  transition-property: max-height, padding, margin;
  transition-duration: 0.3s;
  overflow: hidden;
}

.vz-field-message.v-enter,
.vz-field-message.v-leave-to
{
  padding-top: 0;
  padding-bottom: 0;
  max-height: 0;
  margin-top: 0;
}

.vz-field-message.v-enter-to,
.vz-field-message.v-leave
{
  padding-top: 14px;
  padding-bottom: 14px;
  max-height: 512px;
  margin-top: 8px;
}

.vz-field-message.vz-info {
  color: rgba(255,255,255,0.7);
}

</style>